import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Contact from './pages/webpage/contact/Contact';
import BuyPage from './pages/webpage/BuyPage/BuyPage';
import HomePage from './pages/webpage/homePage/HomePage';
import AdminDashboard from './pages/admin/adminDashboard/AdminDashboard';
import AddPropertyForm from './pages/admin/addPropertyForm/AddPropertyForm';
import AddEmployForm from './pages/admin/addEmployForm/AddEmployForm';
import PropertyDescription from './pages/webpage/propertyDescription/PropertyDescription';
import Login from './login/Login';
import SuperAdmin from './pages/superAdmin/SuperAdmin';
import ProtectedRoute from './auth/ProtectedRoute';
import { AuthProvider } from './auth/AuthContext';
import EmployeeOtpVerify from './otpVerifyEmployee/EmployeeOtpVerify';
import AddPropertyEmployee from './pages/employee/addPropertyEmployee/AddPropertyEmployee';
import AdminPropertyListing from './pages/admin/adminPropertyListing/AdminPropertyListing';
import AssignLeads from './pages/admin/assignLeads/AssignLeads';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AboutUs from './pages/webpage/Aboutus/AboutUs';
import EditPropertyForm from './pages/admin/editPropertyForm/EditPropertyForm';
import ScrollToTop from "./ScrollToTop";
import AllEmployees from './pages/admin/allEmployees/AllEmployees';
import EditEmployeesForm from './pages/admin/editEmployForm/EditEmployeesForm';
import AssignedLeads from './pages/employee/assignedLeads/AssignedLeads';
import UserRegister from './pages/user/userRegister/UserRegister';
import UserProfile from './pages/user/userProfile/UserProfile';
import UserWishlist from './pages/user/wishlist/Wishlist';
import EmployeePropertyList from './pages/employee/employeePropertyList/EmployeePropertyList';
import ForgotPassword from './forgot-password/ForgotPassword';
import TermsAndConditions from './pages/webpage/termsAndConditions/TermsAndConditions';
import PrivacyPolicy from './pages/webpage/PrivacyPolicy/PrivacyPolicy';
import EditPropertyEmployee from './pages/employee/editPropertyEmployee/EditPropertyEmployee';
import AllJoinUsQueries from './pages/admin/allJoinUsQueries/AllJoinUsQueries';
import OurStory from './pages/webpage/Aboutus/OurStory/OurStory';
import CustomerQuery from './pages/admin/customerQueries/CustomerQuery';
import EmployeeAllProperty from './pages/employee/EmployeeAllProperty';
import EmployeeCreateLead from './pages/employee/EmployeeCreateLead';
import AssignPhoneLead from './pages/admin/assignLeads/AssignPhoneLead';
import EmployeeAssignPhoneLead from './pages/employee/assignedLeads/EmployeeAssignPhoneLead';
import Backgroundimage from './pages/admin/AddBackgroungImage/Backgroundimage';
import GoogleAuthHandler from './login/GoogleAuthHandler';
import UserSetUpProfile from './pages/user/userProfile/UserSetUpProfile';
import NotFound from './pages/NotFound/NotFound';
import Blogs from './pages/webpage/blogs/Blogs';
import AllBlogs from './pages/admin/blogs/AllBlogs';
import CreateBlog from './pages/admin/blogs/CreateBlog';
import BlogDetail from './pages/admin/blogs/BlogDetail';
import BlogDetailPage from './pages/webpage/blogs/BlogDetailPage';
import AllFounders from './pages/admin/founders/AllFounders';
import CreateEditFounder from './pages/admin/founders/Create-Edit-Founder';
import Localities from './pages/admin/locality/localities';
import CreateAndEditLocality from './pages/admin/locality/CreateAndEditLocality';

const theme = createTheme({
  typography: {
    fontFamily: 'Bahnschrift SemiBold, sans-serif',
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--bs-accent)',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'var(--bs-primary)',
          '&.Mui-focused': {
            color: 'var(--bs-accent)',
          },
        },
      },
    },
  },
});



const App = () => {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>

        <Router>
          <GoogleAuthHandler />
          <div className="">
            <ScrollToTop />

            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<HomePage />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/buyPage" element={<BuyPage />} />
              <Route path="/buyPage/:name" element={<BuyPage />} />
              <Route path="propertyDescription/:id" element={<PropertyDescription />} />
              <Route path="aboutUs" element={<AboutUs />} />
              <Route path="/eleganza_story" element={<OurStory />} />
              <Route path="/userRegister" element={<UserRegister />} />
              <Route path="/UserSetUpProfile" element={<UserSetUpProfile />} />
              <Route path="/forgotPassword" element={<ForgotPassword />} />
              <Route path="/termsAndConditions" element={<TermsAndConditions />} />
              <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/employeeOtpVerify" element={<EmployeeOtpVerify />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blogs/:slug" element={<BlogDetailPage />} />

              {/* SuperAdmins */}
              <Route
                path="/superAdmin"
                element={
                  <ProtectedRoute allowedRoles={['superAdmin']}>
                    <SuperAdmin />
                  </ProtectedRoute>
                }
              />

              {/* Admin */}
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <>
                      <Routes>
                        <Route path="adminDashboard" element={<AdminDashboard />} />
                        <Route path="addPropertyForm" element={<AddPropertyForm />} />
                        <Route path="editPropertyForm/:id" element={<EditPropertyForm />} />
                        <Route path="addEmployForm" element={<AddEmployForm />} />
                        <Route path="addEmployForm/:id" element={<AddEmployForm />} />
                        <Route path="editEmployForm/:id" element={<EditEmployeesForm />} />
                        <Route path="adminPropertyListing" element={<AdminPropertyListing />} />
                        <Route path="assignLeads" element={<AssignLeads />} />
                        <Route path="allEmployees" element={<AllEmployees />} />
                        <Route path="allJoinUsQueries" element={<AllJoinUsQueries />} />
                        <Route path="customerQueries" element={<CustomerQuery />} />
                        <Route path="Backgroundimage" element={<Backgroundimage />} />
                        <Route path="blogs" element={<AllBlogs />} />
                        <Route path="blog-detail/:id" element={<BlogDetail />} />
                        <Route path="create-blog" element={<CreateBlog />} />
                        <Route path="create-blog/:id" element={<CreateBlog />} />
                        <Route path="founders" element={<AllFounders />} />
                        <Route path="create-founder" element={<CreateEditFounder />} />
                        <Route path="create-founder/:id" element={<CreateEditFounder />} />
                        <Route path="localities" element={<Localities />} />
                        <Route path="create-locality" element={<CreateAndEditLocality />} />
                        <Route path="create-locality/:id" element={<CreateAndEditLocality />} />

                        {/* Add other admin routes here */}
                      </Routes>
                    </>
                  </ProtectedRoute>
                }
              />
              <Route path="admin/assignLeads/AssignPhoneLead" element={<AssignPhoneLead />} />




              <Route
                path="/user/*"
                element={
                  <ProtectedRoute allowedRoles={['user']}>
                    <>
                      <Routes>
                        <Route path="userProfile" element={<UserProfile />} />
                        <Route path="userWishlist" element={<UserWishlist />} />

                      </Routes>
                    </>
                  </ProtectedRoute>
                }
              />




              <Route
                path="/employee/*"
                element={
                  <ProtectedRoute allowedRoles={['employee']}>
                    <>
                      <Routes>
                        <Route path="employeePropertyForm" element={<AddPropertyEmployee />} />
                        <Route path="editPropertyEmployee/:id" element={<EditPropertyEmployee />} />
                        <Route path="assignedLeads" element={<AssignedLeads />} />
                        <Route path="employeePropertyList" element={<EmployeePropertyList />} />
                        <Route path="EmployeeAllProperty" element={<EmployeeAllProperty />} />
                        <Route path="EmployeeCreateLead/:propertyId" element={<EmployeeCreateLead />} />

                      </Routes>
                    </>
                  </ProtectedRoute>
                }
              />
              <Route path="employeeAssignPhoneLead" element={<EmployeeAssignPhoneLead />} />



              {/* Fallback for unauthorized access */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </Router>
      </ThemeProvider>

    </AuthProvider>
  );
};

export default App;
